/**Import react section */
import React, { useEffect, useState } from 'react'
import { useRouteMatch } from 'react-router-dom'
import propTypes from 'prop-types'
/**Import components section */
import TextBox from '../../common/TextBox'
import TabsWrapper from '../../common/TabsWrapper'
import PanelHeader from '../../common/lateralPanel/PanelHeaderIcon'
import TimeLineCarrier from './TimeLineCarrier'
import PackageTracking from './PackageTracking'
import ButtonSaved from '../../common/Buttons/ButtonSaved'
import Select from '../../common/Selector'

/**Import MaterialUi section */
import { Grid, Typography, Drawer } from '@material-ui/core'
/**Import resources section */
import {
	SPARE_PARTS_IMBERA_USA,
	SPARE_PARTS_IMBERA_MX
} from '../../../resources/RolesEnum'
import { WarehouseType } from '../../../store/helpers/AppConstants'
import { isDeliveredStatus } from '../../../store/helpers/sparePartsStatusColors'
import { hasAuthorization } from '../../../store/session/sessionActions'
import { panelEditUseStyles } from '../resources/useStyles'
import { GetStatusTracking } from '../../../store/helpers/SelectOptions'
import iconFailureDoor from '../../../resources/images/failureWarranty/doorWhite.svg'

/**
 * Panel to edit information traking
 * @param {} props
 */
const EditPanel = (props) => {
	const classes = panelEditUseStyles()
	let match = useRouteMatch()
	const token = match.params.token
	const statusOptions = GetStatusTracking()
	const {
		onUpdateSpartPart,
		isSaving,
		onCloseButtonClick,
		userProfile,
		onCheckShipping,
		isGettingTrackingData
	} = props
	const [partModel, setPartModel] = useState(null)
	const [carrierData, setCarrierData] = useState(null)
	let isAuthorizerCanEditRoleImberaMx = hasAuthorization(userProfile, [
		SPARE_PARTS_IMBERA_MX
	])
	let isAuthorizerCanEditRoleImberaUsa = hasAuthorization(userProfile, [
		SPARE_PARTS_IMBERA_USA
	])

	let canBeEdit =
		(isAuthorizerCanEditRoleImberaMx &&
			partModel &&
			partModel.Warehouse === WarehouseType.MEXICO) ||
		(isAuthorizerCanEditRoleImberaUsa &&
			partModel)
	//partModel.Warehouse === WarehouseType.USA)

	useEffect(() => {
		setPartModel(props.part)
		setCarrierData(props.carrierData)
	}, [props.part, props.carrierData])

	/**
	 * Update comments. Tagged COMMENTS, never STATUS: the backend applies the line's status by hand
	 * only on a save tagged STATUS, and this one carries the status the panel was opened with.
	 */
	const updateSpartPart = () => {
		if (onUpdateSpartPart) {
			onUpdateSpartPart(partModel, 'COMMENTS')
		}
	}

	/**
	 * Function ot update status traking. Tagged STATUS so the backend applies the status even when
	 * the carrier is tracked; an untagged save keeps what TrackingMore recorded (IS-424).
	 * @param {*} name
	 * @param {*} value
	 */
	const updateStatusTraking = (name, value) => {
		const updated = { ...partModel, [name]: value }
		setPartModel(updated)
		if (onUpdateSpartPart) {
			onUpdateSpartPart(updated, 'STATUS')
		}
	}

	/**On change properties */
	const onPropertyChange = (event) => {
		let { name, value } = event.target
		setPartModel({
			...partModel,
			[name]: value
		})
	}

	/**
	 * The tab has two reasons to hold something, and it used to know only one.
	 *
	 * The timeline is the ordinary case. The other appears once a shipment is delivered: the
	 * backend deregisters it from Trackingmore, so its lookup stops answering and there is no
	 * timeline to draw -- and that is the normal end of the cycle, not a failure. The tab is where
	 * the user goes looking for the details, so it is where they have to be told there are none.
	 *
	 * Twin of the same expression on the spare part sales panel.
	 */
	const hasTimeline = !!(carrierData && carrierData.origin_info && carrierData.origin_info.trackinfo)
	// trackingStatus is the line's status as the request currently holds it; partModel carries the
	// copy the panel was opened with, which goes stale the moment a delivery event arrives while
	// the panel is already open. Falls back to the copy so the panel still works if no live
	// status reaches it.
	const hasLiveTrackingStatus = props.trackingStatus !== undefined && props.trackingStatus !== null
	const currentTrackingStatus = hasLiveTrackingStatus ? props.trackingStatus : partModel && partModel.Status
	const isDeliveredWithoutDetails = !hasTimeline && isDeliveredStatus(currentTrackingStatus)

	/**
	 * The option the status selector should be showing. Twin of the one in the sales panel, and
	 * matched without case for the same reason: the options are written Transit and Delivered,
	 * the carrier stores transit and delivered, and an exact comparison left the selector empty
	 * beside a row whose chip already read the status.
	 *
	 * Read from the editable model, not from the live status. This field saves on change and the
	 * store only learns the new value when the PUT returns, so sourcing the display from the store
	 * held a hand-picked status back until the round trip finished and reverted it silently when
	 * the save failed. The live status is for deciding whether the shipment was delivered.
	 */
	const selectedStatusOption =
		statusOptions.find((option) => option.label.toLowerCase() === String((partModel && partModel.Status) || '').trim().toLowerCase()) || null

	const tabsConfig = [
		{
			code: 'comments',
			label: 'COMMENTS',
			content: ''
		},
		{
			code: 'TrackingNumber',
			label: 'DETAIL VIEW',
			content: '',
			disabled: !hasTimeline && !isDeliveredWithoutDetails
		}
	]
	/**Consult tracking number */
	const consultDataByTrackingnNumber = () => {
		if (onCheckShipping) {
			onCheckShipping(partModel.Carrier, partModel.NumberTracking, token)
		}
	}

	const onRenderTabContent = (tab) => {
		let tabContent = null
		switch (tab.code) {
			case 'comments': {
				tabContent = (
					<Grid item xs={12} className={classes.editTab}>
						<TextBox
							active={true}
							disabled={isSaving || !canBeEdit}
							fullWidth
							autoFocus
							multiline
							rows={4}
							name='Comments'
							variant='outlined'
							margin='dense'
							label='COMMENTS'
							onChange={onPropertyChange}
							value={partModel ? partModel.Comments : ''}
						/>
					</Grid>
				)
				break
			}
			case 'TrackingNumber': {
				if (hasTimeline) {
					tabContent = (
						<>
							<TimeLineCarrier
								shippingHistory={carrierData.origin_info.trackinfo}
							/>
						</>
					)
				} else if (isDeliveredWithoutDetails) {
					tabContent = (
						<Grid item xs={12}>
							<Typography variant='body2'>Shipment delivered — no tracking details available.</Typography>
						</Grid>
					)
				} else {
					tabContent = null
				}
				break
			}
			default: {
				tabContent = null
				break
			}
		}
		return tabContent
	}

	return (
		<LateralPanel onClose={onCloseButtonClick}>
			<PanelHeader
				title={`TRACKING DETAILS`}
				onSaveButtonClick={updateSpartPart}
				onCloseButtonClick={onCloseButtonClick}
				canBeSaved={canBeEdit}
				icon={iconFailureDoor}
				isIconSvgOrPng={true}
			/>
			<Grid container>
				<Grid item xs={12} className={classes.titleContainer}>
					<div className={classes.titleLeftContent}>
						<div className={classes.flex}>
							<Typography
								variant='subtitle1'
								className={classes.titleBold}
							>{`Status: `}</Typography>
							{partModel && (
								<div style={{ width: '150px' }}>
									<Select
										options={statusOptions}
										isDisabled={!canBeEdit}
										value={selectedStatusOption}
										onChange={(option) =>
											updateStatusTraking(
												'Status',
												option.label
											)
										}
										margin='dense'
									/>
								</div>
							)}
						</div>
					</div>
					{partModel && partModel.NumberTracking && (
						<Grid
							item
							xs={12}
							className={classes.titleRightContent}
						>
							<Grid
								container
								spacing={1}
								style={{
									display: 'flex',
									alignSelf: 'center',
									alignItems: 'center'
								}}
							>
								<Grid item xs={9}>
									<TextBox
										active={true}
										disabled={true}
										fullWidth
										autoFocus
										name='NumberTracking'
										variant='outlined'
										margin='dense'
										label='Tracking number'
										onChange={onPropertyChange}
										value={
											partModel
												? partModel.NumberTracking
												: ''
										}
									/>
								</Grid>
								{!partModel.IsOtherCarrier &&
									partModel.Carrier && (
										<Grid item xs={3}>
											<ButtonSaved
												title={'Search'}
												onSavedClick={
													consultDataByTrackingnNumber
												}
												isSaving={isGettingTrackingData}
											/>
										</Grid>
									)}
							</Grid>
							<br />
						</Grid>
					)}
				</Grid>
				<Grid item xs={12}>
					{carrierData && (
						<PackageTracking carrierData={carrierData} />
					)}
				</Grid>
				<Grid item xs={12}>
					<TabsWrapper
						tabs={tabsConfig}
						onRenderTabContent={onRenderTabContent}
						className={classes.tabs}
					/>
				</Grid>
			</Grid>
		</LateralPanel>
	)
}

const LateralPanel = (props) => {
	const { onClose, children } = props

	const classes = panelEditUseStyles()

	return (
		<Drawer anchor='right' open={props.open} onClose={onClose}>
			<div className={classes.drawerContent} tabIndex={0}>
				{children}
			</div>
		</Drawer>
	)
}
LateralPanel.propTypes = {
	open: propTypes.bool.isRequired
}
LateralPanel.defaultProps = {
	open: true
}

export default EditPanel
